import { FormEvent, useState } from "react"
import { action_getKlaviyoConsent } from "src/actions/newsletter"
import { getEmailErrorId } from "src/checkout/components/stages/contactForm/validation"
import { checkoutContactStore, mergeCheckoutBillingAddress } from "src/checkout/state/checkoutContactStore"
import { setGlobalErrorMessage } from "src/components/error/state"
import { action_subscribeToKlaviyoList } from "src/components/np-design/sections/newsletter/actions"
import { trackEmailSignup } from "src/tracking/events"
import { recordError } from "src/utilities/errorReporting"

export function handleEmailChange(value: string) {
  const billingAddress = checkoutContactStore.getState().billingAddress
  const error = getEmailErrorId(value)
  const focused = billingAddress.email?.focused

  mergeCheckoutBillingAddress({ email: { value, error, focused } })
}

export function useKlaviyoFormSubmit(listId: string, name: string, onSuccess: (hasConsent: boolean) => void) {
  const email = checkoutContactStore((state) => state.billingAddress.email)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  async function handleSubmit(event: FormEvent) {
    try {
      event.preventDefault()

      if (!email?.value) {
        setGlobalErrorMessage("Bitte gib eine gültige E-Mail-Adresse ein.")
        return
      }

      setLoading(true)
      setError(false)

      await action_subscribeToKlaviyoList({ listId, email: email?.value || "" })

      trackEmailSignup({ listId, name })

      const hasConsent = await action_getKlaviyoConsent(email.value)

      onSuccess(hasConsent)
    } catch (error) {
      recordError("Failed to sign up for newsletter", error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  return { email, loading, error, handleSubmit }
}
